(function () {
  function parseI18n(root) {
    try {
      return JSON.parse(root.querySelector('[data-bmi-i18n]').textContent);
    } catch (error) {
      return {};
    }
  }

  function tReplace(template, vars) {
    var output = template || '';
    Object.keys(vars || {}).forEach(function (key) {
      output = output.split('{{ ' + key + ' }}').join(String(vars[key]));
    });
    return output;
  }

  function initBmiCalculator(root) {
    var i18n = parseI18n(root);
    var gender = 'female';
    var age = (i18n.defaults && i18n.defaults.age) || 30;

    var genderButtons = root.querySelectorAll('[data-bmi-gender]');
    var heightInput = root.querySelector('[data-bmi-height]');
    var weightInput = root.querySelector('[data-bmi-weight]');
    var heightDisplay = root.querySelector('[data-bmi-height-display]');
    var weightDisplay = root.querySelector('[data-bmi-weight-display]');
    var ageDisplay = root.querySelector('[data-bmi-age]');
    var drawer = root.closest('health-calc-drawer');
    var calculateButton =
      (drawer && drawer.querySelector('[data-bmi-calculate]')) ||
      root.querySelector('[data-bmi-calculate]');
    var resultEl = root.querySelector('[data-bmi-result]');

    function setGender(value) {
      gender = value;
      genderButtons.forEach(function (button) {
        button.classList.toggle('is-active', button.dataset.bmiGender === value);
      });
    }

    function updateHeightDisplay() {
      heightDisplay.innerHTML =
        heightInput.value + ' <span class="health-calc__range-unit">' + (i18n.cm || 'cm') + '</span>';
    }

    function updateWeightDisplay() {
      weightDisplay.innerHTML =
        weightInput.value + ' <span class="health-calc__range-unit">' + (i18n.kg || 'kg') + '</span>';
    }

    function changeAge(delta) {
      age = Math.min(100, Math.max(10, age + delta));
      ageDisplay.textContent = age;
    }

    function calculate() {
      var heightCm = parseInt(heightInput.value, 10);
      var weightKg = parseInt(weightInput.value, 10);
      var heightM = heightCm / 100;
      var bmi = weightKg / (heightM * heightM);
      var roundedBmi = Math.round(bmi * 10) / 10;

      var categoryKey = 'obese_2';
      var pointer = 95;
      var recommendationKey = 'obese_2';

      if (bmi < 18.5) {
        categoryKey = 'underweight';
        pointer = Math.min((bmi / 18.5) * 28, 28);
        recommendationKey = 'underweight';
      } else if (bmi < 25) {
        categoryKey = 'normal';
        pointer = 28 + ((bmi - 18.5) / 6.5) * 30;
        recommendationKey = 'normal';
      } else if (bmi < 30) {
        categoryKey = 'overweight';
        pointer = 58 + ((bmi - 25) / 5) * 22;
        recommendationKey = 'overweight';
      } else if (bmi < 35) {
        categoryKey = 'obese_1';
        pointer = Math.min(80 + ((bmi - 30) / 5) * 10, 90);
        recommendationKey = 'obese_1';
      }

      var minHealthy = Math.round(18.5 * heightM * heightM);
      var maxHealthy = Math.round(24.9 * heightM * heightM);
      var ideal =
        gender === 'male'
          ? Math.round(heightCm - 100 - (heightCm - 150) / 4)
          : Math.round(heightCm - 100 - (heightCm - 150) / 2.5);
      var difference = Math.round(weightKg - ideal);
      var status =
        difference === 0
          ? i18n.ideal || 'Ideal'
          : difference > 0
            ? tReplace(i18n.over || '+{{ amount }} kg over', { amount: difference })
            : tReplace(i18n.under || '{{ amount }} kg under', { amount: Math.abs(difference) });

      var bmr =
        gender === 'male'
          ? Math.round(10 * weightKg + 6.25 * heightCm - 5 * age + 5)
          : Math.round(10 * weightKg + 6.25 * heightCm - 5 * age - 161);

      var scoreEl = root.querySelector('[data-bmi-score]');
      var categoryEl = root.querySelector('[data-bmi-category]');
      scoreEl.textContent = roundedBmi;
      categoryEl.className = 'health-calc__bmi-category h6 health-calc__bmi-category--' + categoryKey;
      categoryEl.textContent = (i18n.categories && i18n.categories[categoryKey]) || categoryKey;
      root.querySelector('[data-bmi-pointer]').style.insetInlineStart = pointer + '%';
      root.querySelector('[data-bmi-range]').textContent = minHealthy + '–' + maxHealthy + ' ' + (i18n.kg || 'kg');
      root.querySelector('[data-bmi-ideal]').textContent = ideal + ' ' + (i18n.kg || 'kg');
      root.querySelector('[data-bmi-status]').textContent = status;
      root.querySelector('[data-bmi-bmr]').textContent = bmr + ' ' + (i18n.kcal || 'kcal');
      root.querySelector('[data-bmi-advice]').textContent =
        (i18n.recommendations && i18n.recommendations[recommendationKey]) || '';

      resultEl.hidden = false;
      resultEl.classList.add('is-visible');
    }

    genderButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        setGender(button.dataset.bmiGender);
      });
    });

    heightInput.addEventListener('input', updateHeightDisplay);
    weightInput.addEventListener('input', updateWeightDisplay);
    root.querySelector('[data-bmi-age-minus]').addEventListener('click', function () {
      changeAge(-1);
    });
    root.querySelector('[data-bmi-age-plus]').addEventListener('click', function () {
      changeAge(1);
    });
    if (calculateButton) {
      calculateButton.addEventListener('click', calculate);
    }
  }

  function boot() {
    document.querySelectorAll('[data-bmi-calculator]').forEach(initBmiCalculator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
